export const useBlogItem = (props) => {
  const { blogItem } = props;

  let day, month, year;
  if (blogItem && blogItem.publish_date) {
    let timeStamp = new Date(blogItem.publish_date);
    day = timeStamp.getDate();

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    month = months[timeStamp.getMonth()];
    year = timeStamp.getFullYear();
  }

  const isMobile = () => {
    return window.innerWidth < 767;
  };

  return {
    blogItem,
    day,
    month,
    year,
    isMobile,
  };
};
